import view from './header'
export default view
